import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = { url: String }

  connect() { this.generation = 0 }

  disconnect() {
    clearTimeout(this.timer)
    this.abort?.abort()
    this.generation++
  }

  search() {
    clearTimeout(this.timer)
    this.abort?.abort()
    const generation = ++this.generation
    const query = this.inputTarget.value.trim()
    if (!query) return this.message("Search the articles, series and videos.")
    this.timer = setTimeout(() => this.fetchResults(query, generation), 180)
  }

  async fetchResults(query, generation) {
    this.abort = new AbortController()
    this.message("Finding a good thread…")
    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("q", query)
      url.searchParams.set("format", "json")
      const response = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin", signal: this.abort.signal })
      if (!response.ok) throw new Error("Search unavailable")
      const data = await response.json()
      if (generation !== this.generation || !this.element.isConnected) return
      this.renderResults(data)
    } catch (error) {
      if (error.name !== "AbortError" && generation === this.generation) this.message("Search is taking a moment. Press Enter to open the search page.")
    }
  }

  renderResults(data) {
    const fragment = document.createDocumentFragment()
    let count = 0
    for (const [key, label] of [["series", "Series"], ["articles", "Article"], ["videos", "Video"]]) {
      for (const item of Array.isArray(data[key]) ? data[key] : []) {
        let url
        try { url = new URL(item.url, window.location.origin) } catch { continue }
        if (!["http:", "https:"].includes(url.protocol)) continue
        const link = document.createElement("a")
        link.className = "search-result"
        link.href = url.href
        const text = document.createElement("span")
        const type = document.createElement("small")
        type.textContent = label
        text.append(type, document.createTextNode(item.title || "Untitled"))
        link.append(text)
        fragment.append(link)
        count++
      }
    }
    if (!count) return this.message("No matching threads. Try a different word.")
    this.resultsTarget.replaceChildren(fragment)
  }

  message(text) {
    const paragraph = document.createElement("p")
    paragraph.textContent = text
    this.resultsTarget.replaceChildren(paragraph)
  }

  submit() {
    // Retain the normal GET form: the full results page is usable without JavaScript.
    this.abort?.abort()
  }
}
